// extracted by mini-css-extract-plugin
export default {"title":"Nr_M6U","list":"zASEDw","item":"Rl3NjD","button":"nhGLpe"};